import { useState } from 'react'

import PricingCard from '@/components/sections/home/PricingCard'
import Container from '@/components/ui/Container'
import Eyebrow from '@/components/ui/Eyebrow'
import { useData } from '@/hooks/useLocale'

/** The plans side by side, with a monthly / yearly switch. */
export default function PricingSection() {
  const { PRICING } = useData()
  const [billingId, setBillingId] = useState(PRICING.billing[0].id)
  const billing = PRICING.billing.find((b) => b.id === billingId)

  return (
    <section id="pricing" className="bg-surface py-[clamp(64px,9vw,110px)]">
      <Container className="flex flex-col gap-12">
        <div className="flex flex-wrap items-end gap-6">
          <div className="flex min-w-70 flex-1 flex-col gap-2.5">
            <Eyebrow className="text-subtle">{PRICING.eyebrow}</Eyebrow>
            <h2 className="text-[clamp(32px,3.4vw,46px)] tracking-[-0.025em]">
              {PRICING.title}
            </h2>
            <span className="text-sm text-subtle">{PRICING.note}</span>
          </div>

          <div className="flex gap-1 rounded-full bg-white p-1">
            {PRICING.billing.map((option) => {
              const on = option.id === billingId
              return (
                <button
                  key={option.id}
                  type="button"
                  aria-pressed={on}
                  onClick={() => setBillingId(option.id)}
                  className={`flex h-[38px] cursor-pointer items-center rounded-full px-4 text-[13px] font-medium whitespace-nowrap ${on ? 'bg-brand text-white' : 'text-muted'}`}
                >
                  {option.label}
                </button>
              )
            })}
          </div>
        </div>

        <div className="grid items-stretch gap-3 sm:grid-cols-2 md:grid-cols-4">
          {PRICING.plans.map((plan) => (
            <PricingCard key={plan.name} plan={plan} billing={billing} />
          ))}
        </div>
      </Container>
    </section>
  )
}
